export const VALID_CHARACTERS = /^[a-zÀ-ÿ\d\-_'\s]+$/i;
export const RESTRICTED_WORDS = [
  "alias",
  "admin",
  "administratör",
  "administrator",
  "ifrågasätt",
  "ifragasatt",
  "kundtjänst",
  "moderator",
];
